import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import './Message.css';

let host;
let users = 0;
/** Transient feedback only; progress and actionable persistent states stay in-page. */
export default function Message({ message, onClose, type = 'success', duration = 5000 }) {
  const [container, setContainer] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  const text = !message ? '' : typeof message === 'string' ? message : Array.isArray(message)
    ? message.map(item => typeof item === 'string' ? item : item?.msg).filter(Boolean).join('；')
    : message.message || message.msg || '操作失败，请稍后重试';
  useEffect(() => {
    if (!host) {
      host = document.createElement('div');
      host.className = 'app-messages';
      document.body.appendChild(host);
    }
    users += 1;
    setContainer(host);
    return () => { users -= 1; if (!users) { host.remove(); host = null; } };
  }, []);
  useEffect(() => {
    setDismissed(false);
    if (!text || duration <= 0) return undefined;
    const timer = setTimeout(() => { setDismissed(true); closeRef.current?.(''); }, duration);
    return () => clearTimeout(timer);
  }, [text, duration]);
  if (!text || dismissed || !container) return null;
  const Icon = type === 'success' ? CheckCircle2 : type === 'error' ? AlertCircle : Info;
  return createPortal(<div className={`app-message app-message--${type}`} role={type === 'error' ? 'alert' : 'status'} aria-atomic="true">
    <Icon size={18} aria-hidden="true" className="app-message-icon" />
    <span>{text}</span>
    <button type="button" aria-label="关闭消息" onClick={() => { setDismissed(true); onClose?.(''); }}><X size={16} aria-hidden="true" /></button>
  </div>, container);
}
